import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { chakra } from '@chakra-ui/react';
import { colors } from '@laliga-cdac/provider';
import { get } from 'lodash-es';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ToasterMsg = function ToasterMsg(_ref) {
  var msg = _ref.msg;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return React.createElement(React.Fragment, null, t(msg));
};

var useToastTheme = function useToastTheme(_ref) {
  var theme = _ref.theme;
  var toastColorTheme = {
    error: get(colors, theme == null ? void 0 : theme.error) || colors.corporateRed[500],
    info: get(colors, theme == null ? void 0 : theme.info) || colors.corporateBlue[500],
    success: get(colors, theme == null ? void 0 : theme.success) || colors.corporateGreen[500],
    warning: get(colors, theme == null ? void 0 : theme.warning) || colors.corporateYellow[500]
  };
  useEffect(function () {
    document.documentElement.style.setProperty('--toastify-color-error', toastColorTheme.error);
    document.documentElement.style.setProperty('--toastify-color-info', toastColorTheme.info);
    document.documentElement.style.setProperty('--toastify-color-success', toastColorTheme.success);
    document.documentElement.style.setProperty('--toastify-color-warning', toastColorTheme.warning);
  }, [theme]);
};

var toastStyles = {
  '.Toastify__toast-container': {
    width: 'inherit',
    maxWidth: '450px'
  },
  '.Toastify__toast': {
    borderRadius: 'none',
    fontFamily: 'CoreSans',
    color: 'white',
    width: 'fit-content'
  },
  '.Toastify__toast-body': {
    alignItems: 'start',
    marginTop: '4px',
    marginLeft: '6px'
  },
  '.Toastify__close-button > svg': {
    width: '20px',
    height: '20px',
    margin: '12px',
    color: 'white'
  },
  '.Toastify__progress-bar': {
    backgroundColor: 'white'
  }
};
var _excluded = ["theme"];

var ToasterContainer = function ToasterContainer(_ref) {
  var theme = _ref.theme,
      args = _objectWithoutPropertiesLoose(_ref, _excluded);

  useToastTheme({
    theme: theme
  });
  return React.createElement(chakra.div, {
    sx: toastStyles
  }, React.createElement(ToastContainer, Object.assign({
    autoClose: 3000
  }, args, {
    theme: "colored",
    icon: false
  })));
};

var toastTypes = {
  error: toast.TYPE.ERROR,
  success: toast.TYPE.SUCCESS,
  info: toast.TYPE.INFO,
  warning: toast.TYPE.WARNING,
  "default": toast.TYPE.SUCCESS
};

var getType = function getType(type) {
  return toastTypes[type] || toastTypes["default"];
};
/** Abre un nuevo toast actualizable */


function newToast(msg, toastId, type, config) {
  if (type === void 0) {
    type = 'default';
  }

  toast(React.createElement(ToasterMsg, {
    msg: msg
  }), _extends({
    toastId: toastId,
    type: getType(type)
  }, config));
}
/** Actualiza un toast por su id */


function updateToast(msg, toastId, type, autoClose) {
  if (type === void 0) {
    type = 'default';
  }

  toast.update(toastId, {
    type: getType(type),
    autoClose: autoClose,
    render: React.createElement(ToasterMsg, {
      msg: msg
    })
  });
}

export { ToasterContainer, newToast, updateToast };